import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SocialShareBtnComponent } from './components/social-share-btn/social-share-btn.component';
import { FbShareModule } from '../fb-share/fb-share.module';
import { WhatsappShareModule } from '../whatsapp-share/whatsapp-share.module';
import { TelegramShareModule } from '../telegram-share/telegram-share.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [
    CommonModule,
    FbShareModule,
    WhatsappShareModule,
    TelegramShareModule,
    MatButtonModule,
    MatIconModule
  ],
  declarations: [SocialShareBtnComponent],
  exports: [SocialShareBtnComponent],
})
export class SocialShareBtnModule { }
